module.exports = __webpack_public_path__ + "static/media/md-document-duplicate.9b631f2b.svg";